import {createFileRoute, SearchSchemaInput} from '@tanstack/react-router'
import SignupView from "../../signup/SignupView.tsx";

export const Route = createFileRoute('/signup/')({
    validateSearch: (search: Record<string, unknown> & SearchSchemaInput) => ({
        redirect: search.redirect as string | undefined,
    }),
    component: RouteComponent,
})

function RouteComponent() {
  return <SignupView />
}
